import { AuditType } from "./audit.type";

export enum AuditItemStatus {
  VIEWED = "Просмотрено",
  UNVIEWED = "Не просмотрено",
}

export interface IAuditItem {
  _id: string;
  auditId: string;
  type: AuditType;
  itemId: string;
  itemName: string;
  quantity: number;
  quantityKg?: number;
  actualQuantity: number;
  actualQuantityKg?: number;
  price: {
    USD: number;
    UZS: number;
  };
  difference: {
    USD: number;
    UZS: number;
  };
  status: AuditItemStatus;
}
